"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var modal_1 = __importDefault(require("../../../plugins/modal"));
var inline_loader_1 = __importDefault(require("./inline_loader"));
exports.default = (function (props) {
    var _a = __read(React.useState(false), 2), didRequestClose = _a[0], setDidRequestClose = _a[1];
    var error = props.error, isLoading = props.isLoading, loadingText = props.loadingText;
    var handleCloseClick = function () { return setDidRequestClose(true); };
    return (React.createElement(modal_1.default, { disableClose: true, handleClose: function () { return null; }, isOpen: !!(isLoading || error) && !didRequestClose },
        React.createElement("div", { className: 'text-center padding-4' },
            error && (React.createElement("div", { className: 'font-lighter font-size-small' },
                React.createElement("div", { className: 'margin-bottom-6' },
                    React.createElement("p", null,
                        "Oh poop! An error occurred.",
                        React.createElement("br", null),
                        " Our team has been notified.")),
                React.createElement("div", null,
                    React.createElement("a", { className: 'text-underline', onClick: handleCloseClick }, "Close")))),
            React.createElement(inline_loader_1.default, { isLoading: isLoading, loadingText: loadingText }))));
});
